import { teamsActivities } from '../componentes/utils/TeamsActivities/teamsActivities';
import { style } from '../style';

export function get_activities(state = { data: [] }, action) {
  if (action.type === 'GET_ACTIVITIES') {
    if (!action.reset) {
      if (action.data.length >= 1) {
        action.data.map(function(activities) {
          state.data.push(activities);
        });
      } else {
        state.data = [];
      }
    } else {
      state.data = action.data;
    }

    teamsActivities[style.teamName.name] = action.data;

    return {
      data: state.data
    };
  }
  return state;
}
